import { combineReducers } from 'redux';
import { UUID } from '../util';
import find from 'lodash.find';
import element from './element-reducers';
import options from './column-options-reducers';
import {
  REMOVE,

  INSERT_ELEMENT_INTO_COLUMN,
  REMOVE_ELEMENT_FROM_COLUMN,
  REINDEX_ELEMENTS,

  SET_BUTTON_ELEMENT_TEXT,
  SET_BUTTON_ELEMENT_URL,
  SET_BUTTON_ELEMENT_TARGET,
  SET_BUTTON_ELEMENT_CORNER_RADIUS,
  SET_BUTTON_ELEMENT_WIDTH,
  SET_BUTTON_ELEMENT_PADDING,

  SET_IMAGE_ELEMENT_FILE_INFO,
  SET_IMAGE_ELEMENT_URL,
  SET_IMAGE_ELEMENT_WIDTH,
  SET_IMAGE_ELEMENT_HEIGHT,
  SET_IMAGE_ELEMENT_ALIGN,

  SET_SEARCH_TEXT_WIDTH,
  SET_SEARCH_VERTICAL_PADDING,
  SET_SEARCH_TEXT_BG_COLOR,
  SET_SEARCH_TEXT_COLOR,
  SET_SEARCH_BORDER_COLOR,
  SET_SEARCH_BUTTON_STYLE,
  SET_SEARCH_BUTTON_BG_COLOR,
  SET_SEARCH_BUTTON_TEXT_ICON_COLOR,
  SET_SEARCH_BUTTON_CONTENT,
  SET_SEARCH_ICON_COLOR,
  SET_SEARCH_PLACEHOLDER_TEXT,

  LANGUAGE_SELECTOR_SELECT,
  LANGUAGE_SELECTOR_MOVE_UP,
  LANGUAGE_SELECTOR_MOVE_DOWN,
  LANGUAGE_SELECTOR_REMOVE,
  LANGUAGE_SELECTOR_SAVE,
  LANGUAGE_SELECTOR_ENABLE_FLAG,

  SET_SHOPPING_ICON_ELEMENT_FILE_INFO,
  SET_SHOPPING_ICON_ELEMENT_ICON_SIZE,
  SET_SHOPPING_ICON_ELEMENT_ICON_COLOR,
  SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR,

  SET_NAVIGATION_MENU,
  SET_NAVIGATION_STYLE,
  SET_NAVIGATION_TEXT_COLOR,
  SET_NAVIGATION_TEXT_HOVER_COLOR,
  SET_NAVIGATION_ACCENT_COLOR,

  SOCIAL_MEDIA_SELECT,
  SOCIAL_MEDIA_MOVE_UP,
  SOCIAL_MEDIA_MOVE_DOWN,
  SOCIAL_MEDIA_REMOVE,
  SOCIAL_MEDIA_SAVE,
  SOCIAL_MEDIA_CHANGE_COLOR,
  SOCIAL_MEDIA_CHANGE_HOVER_COLOR,
  SOCIAL_MEDIA_CHANGE_ICON_SIZE,

  DIVIDER_CHANGE_COLOR,
  DIVIDER_CHANGE_WIDTH,
  DIVIDER_CHANGE_VERTICAL_PADDING,

  TEXTBOX_CHANGE_TEXT,

  SET_LOGO_ELEMENT_WIDTH,
  SET_LOGO_ELEMENT_HEIGHT,
  SET_LOGO_ELEMENT_LINK_HOMEPAGE,
  SET_LOGO_ELEMENT_MARGIN,
  SET_LOGO_ELEMENT_PADDING,
} from '../actions/action-names';

const insertElementIntoColumn = (elements, action) => {
  if (action.dropElement) {
    return find(elements, e => e.id === action.element.id)
      ? elements.filter(e => e.id !== action.element.id)
      : elements;
  }

  return [
    ...elements.slice(0, action.index),
    element(action.element, action),
    ...elements.slice(action.index)
  ];
};

const removeElementFromColumn = (elements, action) => {
  return elements.filter(element => element.id !== action.id);
};

const reindexElements = (elements, sourceIndex, targetIndex) => {
  const result = [ ...elements ];
  result.splice(sourceIndex, 1);
  result.splice(targetIndex, 0, elements[sourceIndex]);

  return result;
};

const category = (state = 'UNKNOWN', action) => {
  return state;
};

const id = (state = UUID(), action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const elements = (state = [], action) => {
  switch (action.type) {
    case REMOVE:
      return state.filter(e => e.id !== action.highlightedId);

    case INSERT_ELEMENT_INTO_COLUMN:
      return insertElementIntoColumn(state, action);

    case REMOVE_ELEMENT_FROM_COLUMN:
      return removeElementFromColumn(state, action);

    case REINDEX_ELEMENTS:
      return reindexElements(state, action.sourceIndex, action.targetIndex);

    case SET_BUTTON_ELEMENT_TEXT:
    case SET_BUTTON_ELEMENT_URL:
    case SET_BUTTON_ELEMENT_TARGET:
    case SET_BUTTON_ELEMENT_CORNER_RADIUS:
    case SET_BUTTON_ELEMENT_WIDTH:
    case SET_BUTTON_ELEMENT_PADDING:

    case SET_IMAGE_ELEMENT_FILE_INFO:
    case SET_IMAGE_ELEMENT_URL:
    case SET_IMAGE_ELEMENT_WIDTH:
    case SET_IMAGE_ELEMENT_HEIGHT:
    case SET_IMAGE_ELEMENT_ALIGN:

    case SET_SEARCH_TEXT_WIDTH:
    case SET_SEARCH_VERTICAL_PADDING:
    case SET_SEARCH_TEXT_BG_COLOR:
    case SET_SEARCH_TEXT_COLOR:
    case SET_SEARCH_BORDER_COLOR:
    case SET_SEARCH_BUTTON_STYLE:
    case SET_SEARCH_BUTTON_BG_COLOR:
    case SET_SEARCH_BUTTON_TEXT_ICON_COLOR:
    case SET_SEARCH_BUTTON_CONTENT:
    case SET_SEARCH_ICON_COLOR:
    case SET_SEARCH_PLACEHOLDER_TEXT:

    case LANGUAGE_SELECTOR_SELECT:
    case LANGUAGE_SELECTOR_MOVE_UP:
    case LANGUAGE_SELECTOR_MOVE_DOWN:
    case LANGUAGE_SELECTOR_ENABLE_FLAG:

    case SET_SHOPPING_ICON_ELEMENT_FILE_INFO:
    case SET_SHOPPING_ICON_ELEMENT_ICON_SIZE:
    case SET_SHOPPING_ICON_ELEMENT_ICON_COLOR:
    case SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR:

    case SET_NAVIGATION_MENU:
    case SET_NAVIGATION_STYLE:
    case SET_NAVIGATION_TEXT_COLOR:
    case SET_NAVIGATION_TEXT_HOVER_COLOR:
    case SET_NAVIGATION_ACCENT_COLOR:

    case SOCIAL_MEDIA_SELECT:
    case SOCIAL_MEDIA_MOVE_UP:
    case SOCIAL_MEDIA_MOVE_DOWN:
    case SOCIAL_MEDIA_CHANGE_COLOR:
    case SOCIAL_MEDIA_CHANGE_HOVER_COLOR:
    case SOCIAL_MEDIA_CHANGE_ICON_SIZE:

    case DIVIDER_CHANGE_COLOR:
    case DIVIDER_CHANGE_WIDTH:
    case DIVIDER_CHANGE_VERTICAL_PADDING:

    case SET_LOGO_ELEMENT_WIDTH:
    case SET_LOGO_ELEMENT_HEIGHT:
    case SET_LOGO_ELEMENT_LINK_HOMEPAGE:
    case SET_LOGO_ELEMENT_MARGIN:
    case SET_LOGO_ELEMENT_PADDING:

    case TEXTBOX_CHANGE_TEXT:
      return state.map(e => e.id === action.id ? element(e, action) : e);

    case LANGUAGE_SELECTOR_REMOVE:
    case LANGUAGE_SELECTOR_SAVE:
      return state.map(e => e.id === action.id ? element(e, {
        ...action,
        langs: e.options.langs
      }) : e);

    case SOCIAL_MEDIA_REMOVE:
    case SOCIAL_MEDIA_SAVE:
      return state.map(e => e.id === action.id ? element(e, {
        ...action,
        icons: e.options.icons
      }) : e);

    default:
      return state;
  }
};

const width = (state = NaN, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default combineReducers({
  category,
  id,
  elements,
  width,
  options
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/column-reducers.js